import React from "react";
import {
  CalendarDays,
  ChevronRight,
  Star,
  Store,
  Trash2,
} from "lucide-react";
import { MySubmittedReview } from "../../../../Redux/storeReview/types";
import {
  formatStuffDate,
  formatStuffLongDate,
  mapReviewToRecord,
} from "../stuffAdapters";

interface ReviewStoresTableProps {
  reviews: MySubmittedReview[];
  loading: boolean;
  page: number;
  limit: number;
  onDelete: (id: string) => void;
}

const renderStars = (rating: number) => (
  <span className="review-stores-rating-badge">
    {Array.from({ length: 5 }, (_, i) => (
      <Star
        key={i}
        size={13}
        strokeWidth={2}
        fill={i < rating ? "currentColor" : "none"}
      />
    ))}
    <b>{rating}</b>
  </span>
);

const ReviewStoresTable: React.FC<ReviewStoresTableProps> = ({
  reviews,
  loading,
  page,
  limit,
  onDelete,
}) => {
  if (loading && reviews.length === 0) {
    return (
      <div className="review-stores-desktop-empty">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  const records = reviews.map((review, i) =>
    mapReviewToRecord(review, (page - 1) * limit + i),
  );

  return (
    <>
      <div className="review-stores-desktop-table-wrap">
        <table className="review-stores-desktop-table">
          <thead>
            <tr>
              <th>S.NO</th>
              <th>DATE</th>
              <th>STORE DETAILS</th>
              <th>RATING</th>
              <th>REVIEW</th>
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody>
            {records.length > 0 ? (
              records.map((record) => (
                <tr key={record.id}>
                  <td className="review-stores-serial-cell">
                    {record.serialNo}
                  </td>
                  <td className="review-stores-date-cell">
                    <strong>{formatStuffDate(record.date)}</strong>
                    <small>{record.time}</small>
                  </td>
                  <td>
                    <div className="review-stores-store-cell">
                      <div className="review-stores-store-cell-copy">
                        <h3>{record.storeName}</h3>
                        <p>
                          <b>Contact :</b> {record.contactNumber}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td>{renderStars(record.rating)}</td>
                  <td>
                    <p className="review-stores-review-text">
                      {record.review}
                    </p>
                  </td>
                  <td>
                    <div className="review-stores-status-actions">
                      <button
                        type="button"
                        className="unliked"
                        onClick={() => onDelete(record.id)}
                        title="Delete Review"
                      >
                        <Trash2 size={13} strokeWidth={2} />
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="review-stores-desktop-empty" colSpan={6}>
                  No reviews found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="review-stores-mobile-content">
        <div className="review-stores-mobile-list">
          {records.length > 0 ? (
            records.map((record) => (
              <div className="review-stores-mobile-card" key={record.id}>
                <span className="review-stores-mobile-serial">
                  {record.serialNo}
                </span>
                <div className="review-stores-mobile-copy">
                  <div className="review-stores-mobile-topline">
                    <span className="review-stores-mobile-status review-stores-mobile-status-liked">
                      {record.rating} ★
                    </span>
                    <span>
                      <CalendarDays size={13} strokeWidth={2} />
                      {formatStuffLongDate(record.date)}
                    </span>
                  </div>
                  <h2>{record.storeName}</h2>
                  <p>{record.review}</p>
                  <button
                    type="button"
                    className="review-stores-mobile-delete"
                    onClick={() => onDelete(record.id)}
                  >
                    <Trash2 size={14} strokeWidth={2} />
                    Delete Review
                  </button>
                </div>
                <ChevronRight
                  className="review-stores-mobile-chevron"
                  size={20}
                  strokeWidth={2}
                />
              </div>
            ))
          ) : (
            <div className="review-stores-mobile-empty">
              <Store size={32} strokeWidth={1.8} />
              <strong>No reviews found</strong>
              <span>Try another search or date range.</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ReviewStoresTable;
